import React, { useRef } from 'react';
import { useIntl } from 'react-intl';
import { Popover, StatusIndicator, Button } from '@amzn/awsui-components-react';
import copyToClipboard from '../utils/copy.utils.js';
import messages from './InlineCodeBlock.messages.js';
import { InlineCodeDiv, InlineCodeContent } from './InlineCodeBlock.styles.js';

const InlineCodeBlock = _ref => {
  let {
    content
  } = _ref;
  const {
    formatMessage
  } = useIntl();
  const copyBtnRef = useRef();
  return /*#__PURE__*/React.createElement(InlineCodeDiv, null, /*#__PURE__*/React.createElement(Popover, {
    size: "small",
    position: "top",
    triggerType: "custom",
    dismissButton: false,
    content: /*#__PURE__*/React.createElement(StatusIndicator, {
      type: "success"
    }, formatMessage(messages.copied))
  }, /*#__PURE__*/React.createElement(Button, {
    ref: copyBtnRef,
    className: "InlineCode__copyBtn",
    iconName: "copy",
    variant: "inline-icon",
    ariaLabel: formatMessage(messages.copyLabel),
    onClick: () => copyToClipboard(content, copyBtnRef)
  })), /*#__PURE__*/React.createElement(InlineCodeContent, null, content));
};
var InlineCodeBlock$1 = InlineCodeBlock;

export { InlineCodeBlock$1 as default };
